import { render, staticRenderFns } from "./CtaBanner.vue?vue&type=template&id=6f67ce2a&scoped=true&"
import script from "./CtaBanner.vue?vue&type=script&lang=js&"
export * from "./CtaBanner.vue?vue&type=script&lang=js&"
import style0 from "./CtaBanner.vue?vue&type=style&index=0&id=6f67ce2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67ce2a",
  null
  
)

export default component.exports